function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.30769 0L0 3.21429V15.4286H3.92308V18H6.53846L9.15385 15.4286H12.4231L17 10.9286V0H1.30769ZM15.0385 10.2857L12.4231 12.8571H8.49996L5.88462 15.4286V12.8571H2.61538V1.92857H15.0385V10.2857Z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1154 4.45982H13.0769V9.64286H11.1154V4.45982ZM6.53846 4.45982H8.5V9.64286H6.53846V4.45982Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18"
  }, props), _ref, _ref2);
};
export default __webpack_public_path__ + "static/media/twitch.4ef28575.svg";
export { SvgComponent as ReactComponent };